import { ApiDefinition } from "./ApiDefinition";
import { APIPromise } from "../services/HttpService";
import { DatasetStringValueMapperDTO } from "components/dashboard/charts/interfaces";

class DatasetMappersApiDefinition extends ApiDefinition {
  constructor() {
    super("/dataset-mappers");
  }

  async getAll(ids?: Array<number | null> | null): APIPromise<DatasetStringValueMapperDTO> {
    if (!ids) return this.get(null);

    const queryParams = ids.map(id => `&ids=${id}`).join("");
    return this.get("?" + queryParams);
}

  

  async getById(id: number | undefined | null): APIPromise<DatasetStringValueMapperDTO> {
    if(id){
        return this.get(`${id}`);
    } else {
        return {data: undefined};
    }  
  }

  async create(data: DatasetStringValueMapperDTO): APIPromise<any> {
    return this.post(null, data);
}


  async update(id: number, data: DatasetStringValueMapperDTO): APIPromise<any> {
    return this.put(`${id}`, data);
  }
  async remove(id: number): APIPromise<any> {
    return this.delete(`${id}`);
  }
}

export const DatasetMappersApi = new DatasetMappersApiDefinition();
